import LISTVIEW from 'src/api/dev/listview'
import FORMVIEW from 'src/api/dev/formview'
import { getFeatureList } from 'src/api/dev/engine'

import * as T from './types'

export default {
    [T.GET_APILIST]({ commit }, { type, webappId }) {
        const target = type === 'list' ? LISTVIEW : FORMVIEW
        commit(T.SET_APILIST, { data: {}, type })
        return target.getAPIList(webappId).then(res => {
            commit(T.SET_APILIST, { data: res, type })
            return res
        })
    },
    [T.GET_API_DATA]({ commit }, { type, params }) {
        const target = type === 'list' ? LISTVIEW : FORMVIEW
        commit(T.SET_API_DATA, { data: null, type })
        return target.getAPIData(params)
            .then(res => {
                commit(T.SET_API_DATA, { data: res, type })
                return res
            })
    },

    [T.GET_LISTVIEW]({ commit }, payload) {
        commit(T.SET_LISTVIEW, {})
        return LISTVIEW.getViewList(payload)
            .then(res => {
                commit(T.SET_LISTVIEW, res)
                return res
            })
    },
    [T.ADD_LISTVIEW](store, payload) {
        return LISTVIEW.addView(payload)
    },
    [T.UPDATE_LISTVIEW](store, payload) {
        return LISTVIEW.updateView(payload)
    },
    [T.DELETE_LISTVIEW](store, payload) {
        return LISTVIEW.deleteView(payload)
    },
    [T.GET_LISTVIEW_DETAIL]({ commit }, payload) {
        commit(T.SET_LISTVIEW_DETAIL, {})

        return LISTVIEW.getViewDetail(payload)
            .then(res => {
                commit(T.SET_LISTVIEW_DETAIL, res)
                return res
            })
    },

    [T.GET_ENGINE_LIST]({ commit }, payload) {
        commit(T.SET_ENGINE_LIST, [])
        return getFeatureList(payload)
            .then(res => {
                commit(T.SET_ENGINE_LIST, res)
                return res
            })
    },
    [T.GET_FORMVIEW]({ commit }, payload) {
        commit(T.SET_FORMVIEW, {})
        return FORMVIEW.getViewList(payload)
            .then(res => {
                commit(T.SET_FORMVIEW, res)
                return res
            })
    },
    [T.ADD_FORMVIEW](store, payload) {
        return FORMVIEW.addView(payload)
    },
    [T.COPY_FORMVIEW](store, payload) {
        return FORMVIEW.copyView(payload)
    },
    [T.UPDATE_FORMVIEW](store, payload) {
        return FORMVIEW.updateView(payload)
    },
    [T.DELETE_FORMVIEW](store, payload) {
        return FORMVIEW.deleteView(payload)
    },
    [T.GET_FORMVIEW_DETAIL]({ commit }, payload) {
        commit(T.SET_FORMVIEW_DETAIL, {})

        return FORMVIEW.getViewDetail(payload)
            .then(res => {
                commit(T.SET_FORMVIEW_DETAIL, res)
                return res
            })
    },
    [T.GET_FORM_COMPONENTS](store, payload) {
        return FORMVIEW.getFormComponents(payload)
    }
}
